module.exports = __webpack_public_path__ + "static/media/bell-beaker_EBA_scotland_preview.ade57708.png";